import React, { useEffect, useMemo, useState } from 'react';
import VideoElement from './videoElement';
import { useSelector } from 'react-redux';
import { AttendeeName, Avatar } from '../../common';
import { getMirrorClass, getTrackVideoStatus, logSentryCustomEvent } from '../../../utils/functions';
import AttendeeRecorderName from '../../common/AttendeeRecorderName';


function VideoBlockContainer({ participant, isVideoInactive, isBlocked, isCircular, isAttendeeRecorder }) {
    const trackStreamStatus = useSelector(state => state.conf.trackStreamStatus);
    const mirrorClass = getMirrorClass(participant.jid);
    const { track } = participant;
    const [showWarning, setWarning] = useState(false);

    useEffect(() => {
        let debounceTimer = 0;
        if (isVideoInactive) {
            debounceTimer = setTimeout(() => {
                if (isVideoInactive) {
                    logSentryCustomEvent('VIDEO INACTIVE', 'warning', { participant_name: participant?.name, participant_jid: participant?.jid, isVideoInactive });
                    setWarning(true);
                }
            }, 3000);
        }

        return () => {
            clearTimeout(debounceTimer);
            setWarning(false);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVideoInactive]);

    const _streamStatus = useMemo(() => {
        return getTrackVideoStatus(track);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [track, trackStreamStatus]);

    return (
        <div
            className={`${!isAttendeeRecorder && 'videoBlockInner'}`}
            key={participant.jid + '_' + participant.type + '_child1'}>
            {
                isAttendeeRecorder ? (
                    <AttendeeRecorderName name={participant} isCircular={isCircular} />
                ) :
                    participant.track && !showWarning && !isBlocked ? (
                        <>
                            <VideoElement track={track}
                                className={mirrorClass} />
                            {/* When video is visible */}

                            <AttendeeName
                                name={participant.name}
                                userkey={`${participant.jid}_${participant.type}_child2`}
                                isCircular={isCircular}
                            />


                            {/* When video is off */}
                        </>
                    ) : (
                        <>
                            <Avatar
                                participant={participant}
                                userkey={
                                    participant.jid + '_' + participant.type + '_child2'
                                }
                                showWarning={showWarning}
                                streamStatus={_streamStatus}
                                isBlocked={isBlocked}
                                isCircular={isCircular}
                            />

                        </>
                    )}


        </div>
    );
}

export default VideoBlockContainer;
